import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './theme.css';
import { wbPath } from './wbPaths';
import { useWbNavigate } from './WbRouteContext';
import { clearAuth } from '../utils/auth';
import DemoAccessBanner from './DemoAccessBanner';

export default function WbShell({ children, banner = false }) {
  const navigate = useWbNavigate();

  useEffect(() => {
    document.documentElement.lang = 'ru';
    document.documentElement.classList.add('wb-preview-active');
    document.body.classList.add('wb-preview-active');
    return () => {
      document.documentElement.lang = 'en';
      document.documentElement.classList.remove('wb-preview-active');
      document.body.classList.remove('wb-preview-active');
    };
  }, []);

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  return (
    <div className="wb-preview-root">
      <DemoAccessBanner />
      {banner && (
        <div className="wb-preview-banner" role="status">
          <span>
            Новый дизайн (MVP) — тестовая версия для селлеров WB. Основной интерфейс:{' '}
            <Link to="/dashboard">/dashboard</Link>
          </span>
          <div className="flex items-center gap-2">
            <Link to={wbPath('/dashboard')} className="!no-underline opacity-90 hover:opacity-100 text-xs">
              Обновить
            </Link>
          </div>
        </div>
      )}
      {children}
      <div id="modal-portal-root" />
    </div>
  );
}

export function WbTopBar({ title, subtitle, backTo, onLogout }) {
  return (
    <header className="wb-topbar">
      <div className="min-w-0">
        {backTo && (
          <button type="button" onClick={backTo} className="wb-btn-ghost mb-1 -ml-2">
            ← Назад
          </button>
        )}
        <h1 className="text-xl font-bold text-[var(--wb-text)] truncate">{title}</h1>
        {subtitle && (
          <p className="text-sm text-[var(--wb-text-muted)] mt-0.5 truncate">{subtitle}</p>
        )}
      </div>
      {onLogout && (
        <button type="button" onClick={onLogout} className="wb-btn-secondary shrink-0">
          Выйти
        </button>
      )}
    </header>
  );
}
